import type { TenderData } from "@/shared/models/TenderModels";

// Mock Data
export const mockTenders: TenderData[] = [
  {
    id: 1,
    category: "Texnologiya",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg", // Replace with actual logo path
    title: "Ofis avadanlıqları və kompüter texnikasının təchizatı tenderi",
    description: `Qısa təsvir: "Bakı ofisləri üçün 50 ədəd masaüstü kompüter, 25 ədəd laptop və müvafiq periferiya avadanlıqlarının alınması üzrə tender elan edilir."`,
    status: "Müddəti bitmiş",
    location: "Bakı",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "ofis-avadanliqlari-ve-komputer-texnikasinin-techizati-tenderi"
  },
  {
    id: 2,
    category: "Təchizat",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Market şəbəkəsi üçün vitrin soyuducuların təchizatı",
    description: `Bakı şəhərində yerləşən market şəbəkəsi üçün müxtəlif ölçülü vitrin soyuducuların alınması və quraşdırılması`,
    status: "Davam edir",
    location: "Bakı",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "market-sebekesi-ucun-vitrin-soyuducularin-techizati" 
  },
    {
    id: 3,
    category: "Tikinti",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Grand-Mart MMC 135 Mağazası əsaslı təmiri üzrə tikinti işlərinin satınalınması",
    description: `Azərbaycan Respublikası Grand-Mart MMC tərəfindən "Bakı şəhəri, Nəsimi rayonu, Rəsulzadə küçəsi, 135 ünvannında yerləşən Grand-Mart 135 Mağazası"nın əsaslı təmiri üzrə tikinti işlərinin satın alınması" üzrə açıq tender elan edilir.`,
    status: "Davam edir",
    location: "Bakı",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "grand-mart-mmc-135-magazasi-esasli-temiri-uzre-tikinti-ishlerinin-satin-alinmasi-3" 
  },
   {
    id: 4,
    category: "Tikinti",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Grand-Mart MMC 135 Mağazası əsaslı təmiri üzrə tikinti işlərinin satınalınması",
    description: `Azərbaycan Respublikası Grand-Mart MMC tərəfindən "Bakı şəhəri, Nəsimi rayonu, Rəsulzadə küçəsi, 135 ünvannında yerləşən Grand-Mart 135 Mağazası"nın əsaslı təmiri üzrə tikinti işlərinin satın alınması" üzrə açıq tender elan edilir.`,
    status: "Davam edir",
    location: "Bakı",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "grand-mart-mmc-135-magazasi-esasli-temiri-uzre-tikinti-ishlerinin-satin-alinmasi-4" 
  },
   {
    id: 5,
    category: "Tikinti",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Grand-Mart MMC 135 Mağazası əsaslı təmiri üzrə tikinti işlərinin satınalınması",
    description: `Azərbaycan Respublikası Grand-Mart MMC tərəfindən "Bakı şəhəri, Nəsimi rayonu, Rəsulzadə küçəsi, 135 ünvannında yerləşən Grand-Mart 135 Mağazası"nın əsaslı təmiri üzrə tikinti işlərinin satın alınması" üzrə açıq tender elan edilir.`,
    status: "Müddəti bitmiş",
    location: "Sumqayıt",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "grand-mart-mmc-135-magazasi-esasli-temiri-uzre-tikinti-ishlerinin-satin-alinmasi-5" 
  },
  {
    id: 6,
    category: "Tikinti",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Grand-Mart MMC 135 Mağazası əsaslı təmiri üzrə tikinti işlərinin satınalınması",
    description: `Azərbaycan Respublikası Grand-Mart MMC tərəfindən "Bakı şəhəri, Nəsimi rayonu, Rəsulzadə küçəsi, 135 ünvannında yerləşən Grand-Mart 135 Mağazası"nın əsaslı təmiri üzrə tikinti işlərinin satın alınması" üzrə açıq tender elan edilir.`,
    status: "Davam edir",
    location: "Sumqayıt",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "grand-mart-mmc-135-magazasi-esasli-temiri-uzre-tikinti-ishlerinin-satin-alinmasi-6" 
  },
  {
    id: 7,
    category: "Tikinti",
    companyName: "Grand-Mart MMC",
    companyLogo: "/logo-placeholder.svg",
    title: "Grand-Mart MMC 135 Mağazası əsaslı təmiri üzrə tikinti işlərinin satınalınması",
    description: `Azərbaycan Respublikası Grand-Mart MMC tərəfindən "Bakı şəhəri, Nəsimi rayonu, Rəsulzadə küçəsi, 135 ünvannında yerləşən Grand-Mart 135 Mağazası"nın əsaslı təmiri üzrə tikinti işlərinin satın alınması" üzrə açıq tender elan edilir.`,
    status: "Davam edir",
    location: "Sumqayıt",
    postedAgo: "3 ay əvvəl",
    deadline: "24.01.24-dək",
    bids: "12 təklif",
    views: "112 baxış",
    slug: "grand-mart-mmc-135-magazasi-esasli-temiri-uzre-tikinti-ishlerinin-satin-alinmasi-7" 
  },
  // Add more mock tenders as needed
]; 